import styled, { css } from 'styled-components';
import { fadeIn } from '../../shared';

const ProjectEntriesWrapper = styled.div`
  animation: ${fadeIn} .3s both ease-in-out;

  > div {
    :first-of-type {
      margin-top: 8px;
      margin-bottom: 8px;
    }

    :last-of-type {
      border-bottom: 1px solid #e6e6e6;
    }
  }
`;

const deletableRowStyles = props => {
  if (props.applyDeletableRowStyles) {
    return css`
      margin-right: -0.5rem;
      padding-right: 1rem;
    `;
  }
}

export {
  ProjectEntriesWrapper,
  deletableRowStyles,
};